"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var person_icon_svg_1 = __importDefault(require("@assets/components/directory/directory-results/person-icon.svg"));
var copy_email_icon_svg_1 = __importDefault(require("@assets/components/directory/directory-results/copy-email-icon.svg"));
var actions_1 = __importDefault(require("../../../../app/components/pages/RootPage/actions"));
var appMargins_1 = __importDefault(require("../../../../app/components/AppMargins/appMargins"));
var RedirectIcon_1 = __importDefault(require("../../../widgets/RedirectIcon"));
var DirectoryFileIcon_1 = __importDefault(require("../../../widgets/DirectoryFileIcon"));
var DirectoryUrlIcon_1 = __importDefault(require("../../../widgets/DirectoryUrlIcon"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        mobilePanel: {
            padding: theme.spacing(1.5),
        },
        personIcon: {
            marginRight: 5,
        },
        copyIcon: {
            position: 'absolute',
            right: '10%',
            '&:focus': {
                outline: 'none',
            },
        },
        goToIcon: {
            position: 'absolute',
            right: '10%',
        },
        row: {
            padding: theme.spacing(3),
        },
        divider: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3),
        },
        shortUrlRow: {
            display: 'box',
            maxWidth: '200px',
            width: '100%',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
        shortUrlInActive: {
            color: '#BBBBBB',
        },
        longLinkText: {
            color: '#BBBBBB',
        },
        stateIcon: {
            verticalAlign: 'middle',
        },
        stateActive: {
            color: '#6d9067',
            textTransform: 'capitalize',
            padding: theme.spacing(3),
        },
        stateInactive: {
            color: '#c85151',
            textTransform: 'capitalize',
            padding: theme.spacing(3),
        },
    });
});
/**
 * @component Popup drawer for mobile view.
 */
var MobilePanel = function (_a) {
    var isOpen = _a.isOpen, setOpen = _a.setOpen, url = _a.url;
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    var dispatch = react_redux_1.useDispatch();
    var onClickEvent = function () {
        copy_to_clipboard_1.default(url.email);
        dispatch(actions_1.default.setSuccessMessage('Email has been copied'));
    };
    // inactive and active icons/ colors
    var getMobileIcon = function () {
        if ((url === null || url === void 0 ? void 0 : url.state) === 'ACTIVE' && (url === null || url === void 0 ? void 0 : url.isFile)) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(DirectoryFileIcon_1.default, { className: classes.stateIcon }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null,
                        "/", url === null || url === void 0 ? void 0 :
                        url.shortUrl),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("p", { className: classes.longLinkText }, url === null || url === void 0 ? void 0 : url.longUrl))));
        }
        if ((url === null || url === void 0 ? void 0 : url.state) === 'ACTIVE' && !(url === null || url === void 0 ? void 0 : url.isFile)) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(DirectoryUrlIcon_1.default, { className: classes.stateIcon }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null,
                        "/", url === null || url === void 0 ? void 0 :
                        url.shortUrl),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("p", { className: classes.longLinkText }, url === null || url === void 0 ? void 0 : url.longUrl))));
        }
        if (url === null || url === void 0 ? void 0 : url.isFile) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(DirectoryFileIcon_1.default, { className: classes.stateIcon, color: "#BBBBBB" }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { className: classes.shortUrlInActive },
                        "/", url === null || url === void 0 ? void 0 :
                        url.shortUrl),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("p", { className: classes.longLinkText }, url === null || url === void 0 ? void 0 : url.longUrl))));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DirectoryUrlIcon_1.default, { className: classes.stateIcon, color: "#BBBBBB" }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", { className: classes.shortUrlInActive },
                    "/", url === null || url === void 0 ? void 0 :
                    url.shortUrl),
                react_1.default.createElement("br", null),
                react_1.default.createElement("p", { className: classes.longLinkText }, url === null || url === void 0 ? void 0 : url.longUrl))));
    };
    return (react_1.default.createElement(core_1.Drawer, { anchor: "bottom", open: isOpen, onBackdropClick: function () { return setOpen(false); }, onEscapeKeyDown: function () { return setOpen(false); } },
        react_1.default.createElement(core_1.Paper, { className: classes.mobilePanel },
            react_1.default.createElement(core_1.Typography, { className: classes.row, variant: "body2" },
                react_1.default.createElement("div", { className: classes.shortUrlRow },
                    getMobileIcon(),
                    (url === null || url === void 0 ? void 0 : url.state) === 'ACTIVE' && (react_1.default.createElement("a", { href: url === null || url === void 0 ? void 0 : url.shortUrl, target: "_blank", rel: "noopener noreferrer" },
                        react_1.default.createElement(RedirectIcon_1.default, { className: classes.goToIcon }))))),
            react_1.default.createElement(core_1.Typography, { variant: "caption", className: (url === null || url === void 0 ? void 0 : url.state) === 'ACTIVE'
                    ? classes.stateActive
                    : classes.stateInactive },
                react_1.default.createElement("b", { style: { fontWeight: 900 } }, '• '), url === null || url === void 0 ? void 0 :
                url.state.toLocaleLowerCase()),
            react_1.default.createElement(core_1.Divider, { className: classes.divider }),
            react_1.default.createElement(core_1.Typography, { className: classes.row, variant: "body2" },
                react_1.default.createElement("img", { className: classes.personIcon, src: person_icon_svg_1.default, alt: "person icon" }), url === null || url === void 0 ? void 0 :
                url.email,
                react_1.default.createElement("input", { type: "image", src: copy_email_icon_svg_1.default, onClick: function () { return onClickEvent(); }, className: classes.copyIcon, alt: "email icon" })))));
};
exports.default = MobilePanel;
